export const REQUEST_DATA_BY_CONTEXT = 'REQUEST_DATA_BY_CONTEXT'
export const RECEIVE_DATA_BY_CONTEXT = 'RECEIVE_DATA_BY_CONTEXT'
export const RESET_DATA_CONTEXT = 'RESET_DATA_CONTEXT'
export const REQUEST_SAVE_ANEXO_PACIENTE = 'REQUEST_SAVE_ANEXO_PACIENTE'
export const RECEIVE_SAVE_ANEXO_PACIENTE = 'RECEIVE_SAVE_ANEXO_PACIENTE'
export const REQUEST_REMOVE_ANEXO_PACIENTE = 'REQUEST_REMOVE_ANEXO_PACIENTE'
export const RECEIVE_REMOVE_ANEXO_PACIENTE = 'RECEIVE_REMOVE_ANEXO_PACIENTE'
export const REQUEST_SAVE_DOC_PACIENTE = 'REQUEST_SAVE_DOC_PACIENTE'
export const RECEIVE_SAVE_DOC_PACIENTE = 'RECEIVE_SAVE_DOC_PACIENTE'
export const REQUEST_SAVE_DATA_TO_NFSE = 'REQUEST_SAVE_DATA_TO_NFSE'
export const RECEIVE_SAVE_DATA_TO_NFSE = 'RECEIVE_SAVE_DATA_TO_NFSE'
export const REQUEST_SAVE_PERSONAL_DATA = 'REQUEST_SAVE_PERSONAL_DATA'
export const RECEIVE_SAVE_PERSONAL_DATA = 'RECEIVE_SAVE_PERSONAL_DATA'
